<template>
    <div>
        <div class="dropdown" v-if="isLoggedIn">
            <a id="js--login"
               data-toggle="dropdown"
			   data-toggle-second="tooltip" data-placement="top" :title="$translate('OD3dprimaV2::Template.vatPlaceholder')"
               href="#"
               aria-expanded="false"
               aria-haspopup="true"
               data-boundary="viewport">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" class="dia-controls-list__svg">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-user"></use>
                </svg>
            </a>
            <div class="dropdown-menu header__dropdown"
                 aria-labelledby="js--login">
                <div class="list-group">
                    <a :href="$ceres.urls.myAccount">
                        {{ $translate("Ceres::Template.loginMyAccount") }}
                    </a>
                    <a href="#" v-logout>
                        {{ $translate("Ceres::Template.loginLogout") }}
                    </a>
                </div>
            </div>
        </div>
        <template v-else>
            <a id="js--login"
               data-toggle="dropdown"
			   data-toggle-second="tooltip" data-placement="top" :title="$translate('OD3dprimaV2::Template.myAccountTooltip')"
			   href="#"
               aria-expanded="false"
               aria-haspopup="true"
               data-boundary="viewport">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" class="dia-controls-list__svg">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-user"></use>
                </svg>
            </a>
            <div class="dropdown-menu header__dropdown" aria-labelledby="js--login">
                <div class="list-group">
                    <a :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal();unmarkInputFields()" data-testing="login-select" :aria-label="$translate('Ceres::Template.login')">
                        <span class="hidden-xs-down">{{ $translate("Ceres::Template.login") }}</span>
                    </a>
                    <a :href="urlRegistration" v-if="showRegistration" data-testing="register-select" :aria-label="$translate('Ceres::Template.loginRegister')">
                        <span class="hidden-xs-down">{{ $translate("Ceres::Template.loginRegister") }}</span>
                    </a>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import ValidationService from "ceres/app/services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ]),

        urlRegistration()
        {
            return App.urls.registration;
        }
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
